import {Field, Form, Formik} from 'formik';
import {useLocation, useParams} from 'react-router-dom';
import CustomButton from 'components/customButton';
import FormikSelect from 'components/formikFields/select';
import UseGetProvince from 'utilities/hooks/province/useGetProvince';
import {ProvincesToOption, findCityOfProvince} from './helper';
import useWantedPost from './hooks/useWantedPost';
import CustomTextArea from './customTextArea';
import {PurchaseRegistrationSchema} from './helper/schema';
import {usePurchase} from 'context/purchaseContext';
import {googleAnalyticsInstance} from 'utilities/helper/googleAnalitics';
import {
  FarmEvents,
  WholesalerEvent,
} from 'utilities/helper/googleAnalitics/EventHelper';
import {unitToPersian} from 'utilities/helper/unitToPersian';
import {gradToPersian} from 'utilities/helper/qualityToPersian';

interface PurchaseRegistrationProps {
  type: 'market' | 'farmer';
}
const PurchaseRegistration = ({type}: PurchaseRegistrationProps) => {
  const {state} = useLocation();
  const {purchaseId} = useParams();
  const {resetForm} = usePurchase();

  const {provinces} = UseGetProvince();
  const {mutate, isLoading} = useWantedPost({resetForm});

  return (
    <Formik
      validationSchema={PurchaseRegistrationSchema}
      initialValues={{
        state: undefined,
        city: undefined,
        hide_phone_number: false,
        title: state
          ? `${state.wanted} ${unitToPersian[state.wanted_unit]} ${
              state.title
            } ${gradToPersian[state.quality]} نیاز دارم.`
          : '',
      }}
      onSubmit={values => {
        const data: wantedBody = {
          profile_type: type,
          city: values.city ? values.city : 0,
          state: values.state ? values.state : 0,
          hide_phone_number: values.hide_phone_number,
          wanted: state.wanted,
          quality: state.quality,
          subproduct: purchaseId ? purchaseId : '',
          title: values.title,
          wanted_unit: state.wanted_unit,
        };

        mutate(data);
        googleAnalyticsInstance.eventGoogleAnalytics(
          type === 'farmer'
            ? FarmEvents.addingWanted
            : WholesalerEvent.addingWanted,
        );
      }}
    >
      {({values}) => {
        const cities = values.state
          ? findCityOfProvince(provinces, values.state)
          : [];
        return (
          <Form className="flex flex-col w-full gap-4 px-4 py-4 mb-6 justify-between">
            <div className="flex flex-col w-full justify-around gap-4">
              <div className="flex flex-col w-full gap-2">
                <span className="font-normal text-[18px] leading-[36px] text-gray-6">
                  متن درخواست:
                </span>
                <Field
                  type="textarea"
                  name="title"
                  rows={9}
                  as={CustomTextArea}
                  placeholder="متن گزارش"
                />
              </div>
              <div className="flex flex-col w-full gap-4">
                <span className="font-normal text-[18px] leading-[36px] text-gray-6 ">
                  محدوده آگهی:
                </span>
                <div className="flex flex-col gap-6">
                  <FormikSelect
                    name="state"
                    label="استان"
                    Options={ProvincesToOption(provinces || [])}
                  />
                  <FormikSelect
                    name="city"
                    label="شهرستان"
                    disabled={!values.state}
                    Options={cities ? cities : []}
                  />
                </div>
              </div>
              <div className="flex items-center my-6">
                <label className="flex items-center gap-4">
                  <Field type="checkbox" name="hide_phone_number" />
                  <span className="text-[14px] font-normal text-gray-6">
                    شماره تلفن در آگهی نمایش داده نشود.
                  </span>
                </label>
              </div>
              <CustomButton
                isLoading={isLoading}
                type="submit"
                title="ثبت آگهی"
                className="!bg-primary"
              />
            </div>
          </Form>
        );
      }}
    </Formik>
  );
};

export default PurchaseRegistration;
